export default status => {
  if (status === 'ACTIVE') {
    return '#099075';
  } if (status === 'PENDING') {
    return '#D17621';
  } return '#D17621';
};
